import { isCaptureItem, isHealItem, type CaptureItem, type HealItem, type Item, type ItemId } from '../../shared/items.ts';
import { el } from './dom.ts';
import { icon } from './icons.ts';

/** Objets connus, reçus du serveur (jeu) ou de l'API (administration) ; triés par nom. */
let catalog = new Map<ItemId, Item>();

export const itemCatalog = {
  set(items: readonly Item[]): void {
    catalog = new Map(items.map((item) => [item.id, item]));
  },
  get: (id: ItemId): Item | undefined => catalog.get(id),
  all: (): Item[] => [...catalog.values()],
  /** Objets de soin, du plus faible au plus fort. */
  heals: (): HealItem[] => [...catalog.values()].filter(isHealItem).sort((a, b) => a.effect.amount - b.effect.amount),
  /** Objets de capture, du plus faible au plus fort. */
  captures: (): CaptureItem[] => [...catalog.values()].filter(isCaptureItem).sort((a, b) => a.effect.bonus - b.effect.bonus),
  name: (id: ItemId): string => catalog.get(id)?.name ?? 'Objet disparu',
};

/** Visuel d'un objet : son image téléversée, sinon son icône teintée. */
export function itemVisual(item: Pick<Item, 'name' | 'image' | 'icon' | 'color'> | undefined, className = ''): HTMLElement {
  if (!item) return icon('bag', { className });
  if (item.image) return el('img', { src: item.image, alt: '', className: `item-image ${className}`.trim() });
  return icon(item.icon, { color: item.color, className });
}

/** Options d'une liste d'objets ; un objet choisi mais supprimé depuis reste affiché, signalé. */
export function itemOptions(selected: ItemId | null): HTMLOptionElement[] {
  const options = itemCatalog.all().map((item) => el('option', { value: item.id, textContent: item.name, selected: item.id === selected }));
  if (selected !== null && selected !== '' && !catalog.has(selected)) {
    options.unshift(el('option', { value: selected, textContent: `⚠ ${selected} (supprimé)`, selected: true }));
  }
  return options;
}
